import { useContext } from 'react';
import { ApiContext } from './context';
export function useApi() {
    return useContext(ApiContext).api;
}
//# sourceMappingURL=use-api.js.map